import script from "./view-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./view-loading.vue?vue&type=script&setup=true&lang=js"

import "./view-loading.vue?vue&type=style&index=0&id=7b017ece&lang=css"

const __exports__ = script;

export default __exports__